module.exports = "img/9.80681d.webp";